import React, { Fragment, useState } from "react";
import { getQRCodeCountFilter } from "../../action/qrcode";
import Alert from "../layout/Alert";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid2 from "@mui/material/Grid2";
import AppButton from "../Common/Button/Button";
import InfoField from "../Common/InfoField/InfoField";
import MuiDatePicker from "../Common/FormInputs/MuiDatePicker";

const QRCodeFilter = ({ setAlert }) => {
    const [startDateFilter, setStartDateFilter] = useState(undefined);
    const [endDateFilter, setEndDateFilter] = useState(undefined);
    const [showQRCodeResult, setShowQRCodeResult] = useState(false);
    const [totalQRCodeCount, setTotalQRCodeCount] = useState(0);

    function handleFilterReset() {
        setStartDateFilter(undefined);
        setEndDateFilter(undefined);
        setShowQRCodeResult(false);
        setTotalQRCodeCount(0);
    }

    const formateDate = (dateFilter) => {
        if (dateFilter) {
            const dateVal = dateFilter.getDate() < 10 ? `0${dateFilter.getDate()}` : dateFilter.getDate();
            const monthVal = dateFilter.getMonth() < 9 ? `0${dateFilter.getMonth() + 1}` : dateFilter.getMonth() + 1;
            return `${dateVal}-${monthVal}-${dateFilter.getFullYear()}`;
        }
    };

    function handleFilter() {
        if (!startDateFilter || startDateFilter === "") {
            setAlert("Invalid Start Date. Start Date Cannot be Empty", "danger");
            return;
        }

        if (!endDateFilter || endDateFilter === "") {
            setAlert("Invalid End Date. End Date Cannot be Empty", "danger");
            return;
        }

        let formmattedStartDate = formateDate(startDateFilter);
        let formattedEndDate = formateDate(endDateFilter);

        getQRCodeCountFilter({
            startTs: formmattedStartDate,
            endTs: formattedEndDate,
        })
            .then((data) => {
                setShowQRCodeResult(true);
                setTotalQRCodeCount(data.count);
            })
            .catch((err) => {
                setShowQRCodeResult(false);
                setAlert(err?.response?.data?.message ?? err.message, "danger");
            });
    }

    return (
        <Fragment>
            <Paper sx={{ p: { xs: 1.5, sm: 2 }, boxShadow: 2, borderRadius: 1, mb: 2, width: "100%", minWidth: 0, boxSizing: "border-box" }}>
                <Alert />
                <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, flexWrap: "wrap", alignItems: { xs: "stretch", sm: "center" }, justifyContent: "flex-start", gap: { xs: 1.5, sm: 2 }, width: "100%", minWidth: 0, maxWidth: "100%" }}>
                    <Box sx={{ minWidth: 0, maxWidth: { xs: "100%", sm: 200 }, width: { xs: "100%", sm: "auto" }, flex: { sm: "0 0 auto" } }}>
                        <MuiDatePicker
                            label="Start Date"
                            value={startDateFilter}
                            maxDate={new Date()}
                            onChange={(date) => setStartDateFilter(date)}
                        />
                    </Box>
                    <Box sx={{ minWidth: 0, width: { xs: "100%", sm: "auto" }, maxWidth: { xs: "100%", sm: "none" } }}>
                        <MuiDatePicker
                            label="End Date"
                            value={endDateFilter}
                            maxDate={new Date()}
                            onChange={(date) => setEndDateFilter(date)}
                        />
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 1.5, flexWrap: "wrap", flex: { sm: "0 0 auto" }, minWidth: 0, maxWidth: "100%" }}>
                        <AppButton variant="primary" size="medium" onClick={handleFilter}>
                            Filter
                        </AppButton>
                        <AppButton variant="ghost" size="medium" onClick={handleFilterReset}>
                            Reset
                        </AppButton>
                    </Box>
                </Box>
            </Paper>

            {showQRCodeResult && (
                <Paper sx={{ p: { xs: 1.5, sm: 2 }, boxShadow: 2, borderRadius: 1, mb: 2, width: "100%", minWidth: 0, boxSizing: "border-box" }}>
                    <Grid2 container spacing={3} sx={{ width: "100%", minWidth: 0, maxWidth: "100%" }}>
                        <Grid2 size={{ xs: 12, md: 6 }} sx={{ minWidth: 0 }}>
                            <InfoField label="Total QR Code Printed" value={totalQRCodeCount} />
                        </Grid2>
                    </Grid2>
                </Paper>
            )}
        </Fragment>
    );
};

export default QRCodeFilter;